import { useQuery } from '@tanstack/react-query';
import messageTemplatesApi from '@/features/dashboard/messageTemplates/api/messageTemplatesApi.ts';
import { messageTemplatesApiQueryKeys } from '@/features/dashboard/messageTemplates/api/messageTemplatesApi.queryKeys.ts';
import { MessageChannel } from '@/features/dashboard/messageTemplates/types/MessageTemplateDto.ts';

const useGetTemplateVariables = (channel: MessageChannel, type: string) => {
  return useQuery({
    queryKey: messageTemplatesApiQueryKeys.variables(channel, type),
    queryFn: () => messageTemplatesApi.getVariables(channel, type),
    enabled: !!type,
  });
};

export default useGetTemplateVariables;
